import * as React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import xss from 'xss';
import _ from 'lodash';

import { ticketCallNotesOrderedListSelectorFactory } from '@/redux/app/selectors/ticket';
import { eventDataSelector } from '@/redux/app/selectors/event';
import { CallNote, NewNoteForm } from '../../note';

export interface AddNotesToCallProps {
  ticket: string;
  callId: string;
  open?: boolean;
  onToggleOpen?: () => void;
}

export const AddNotesToCall = ({ ticket, callId, open, onToggleOpen }: AddNotesToCallProps) => {
  const notesSelector = useMemo(
    () => ticketCallNotesOrderedListSelectorFactory(ticket, callId),
    [ticket, callId],
  );
  const notes = useSelector(notesSelector);
  const lastNote = useSelector(_.partial(eventDataSelector, ticket, _.last(notes)));

  return (
    <div className="add-notes">
      <div
        role="button"
        tabIndex={0}
        onClick={onToggleOpen}
        onKeyPress={onToggleOpen}
        className={classNames('opener', 'noselect', open && 'open')}
        data-note-count={notes?.length ?? 0}
      >
        <span className="note-count">
          {notes && `${notes.length} ${notes.length === 1 ? 'note' : 'notes'}`}
        </span>
        <span
          className="last-note-timestamp"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: lastNote
              ? xss(lastNote.time_ago)
              : 'Add a note',
          }}
        />
        <span className="view hide">{open ? 'Hide notes' : 'View notes'}</span>
      </div>

      <div className={classNames('call-notes-container', !open && 'hide')}>
        <div className="call-notes">
          {notes && notes.map((id) => <CallNote key={id} id={id} ticket={ticket} />)}
        </div>
        <NewNoteForm ticket={ticket} callId={callId} />
        {/* <%= form_for(AvoNote.new(call_id: call.hash_id), url: account_ticket_avo_notes_path(call.account.subdomain, call.ticket.uuid), html: {id: "call-#{call.hash_id}-notes-form", class: "call-notes-form"}, remote: true) do |f| %>
          <%= f.hidden_field :call_id, class: 'note-call-id' %>
          <%= f.text_area :body, placeholder: 'Add a note...', id: nil, class: 'notes-input', data: {role: 'none'} %>
          <%= f.submit 'Save' %>
        <% end %> */}
      </div>
    </div>
  );
};
